// import * as ApiClient from "./../services/ApiClient";
// import { requestColumns, receiveColumns } from "./columns";
// import { receiveColumnsFailure } from "./results";
import {
  setFilterValue,
  setRouterValue,
  setSearchValue,
  setUiValue,
  addValue,
  removeValue,
  setDisplayFields,
  setSortOrder,
  setApiUrls,
  setBrowserLocation,
  setPaginationValue,
} from "./appState";
import { Dispatch } from "redux";
import { All, KeyValue } from "../../interfaces";
import { encodeBrowserPathFromState } from "./browserEncode";
import * as browserLocation from "../services/BrowserLocation";

// async actions to be called
// see also https://redux.js.org/advanced/asyncactions#actions-js-asynchronous

export function fetchResults(query: any, apiPath: string) {
  return function (dispatch: Dispatch, getState: Function) {
    dispatch(setApiUrls(query, apiPath));
  };
}

// Setting browser location
export function updateBrowserLocation(state: All) {
  return function (dispatch: any) {
    const newLocation = encodeBrowserPathFromState(
      (state.appState as any)[state.appState.app],
    );
    dispatch(setBrowserLocation(newLocation));
    browserLocation.setLocation(newLocation);
    dispatch(
      fetchResults(
        (state.appState as any)[state.appState.app],
        (state.appState as any)[state.appState.app].urls.apiPath,
      ),
    );
  };
}

// Common actions we want to do after every filter update
function onQueryUpdate(dispatch: any, state: All) {
  dispatch(updateBrowserLocation(state));
  // TODO: To make this non-auto-update (require clicking button to initiate search),
  //       we'd have to remove one or both of these from onQueryUpdate.
  // Using the button would require wiring the container for that button component
  //       to actions/async setApiUrls.
  // dispatch(fetchResults(state.query, state.config.apiPath));
}

// Every time we update the filter or sort, we want to trigger a data load.
// These compound actions first call the basic 'set' action...
// then grab the updated state of the query params, and use it to fetch fresh results.

export function updateFilter(
  filterField: string,
  filterValue: string | string[] | number | number[] | undefined,
): any {
  return function (dispatch: Dispatch) {
    dispatch(setFilterValue(filterField, filterValue));
  };
}

export function updateRouterHistory(
  routerField: string,
  routerValue: string[] | KeyValue[],
): any {
  return function (dispatch: Dispatch) {
    dispatch(setRouterValue(routerField, routerValue));
  };
}

export function updateSearch(searchField: string, searchValue: string): any {
  return function (dispatch: Dispatch) {
    dispatch(setSearchValue(searchField, searchValue));
  };
}

export function updateUi(
  uiField: string,
  uiValue:
    | string
    | string[]
    | number
    | boolean
    | KeyValue
    | KeyValue[]
    | undefined,
): any {
  return function (dispatch: Dispatch) {
    dispatch(setUiValue(uiField, uiValue));
  };
}

export function updatePagination(
  paginationField: string,
  paginationValue: number,
): any {
  return function (dispatch: Dispatch) {
    dispatch(setPaginationValue(paginationField, paginationValue));
  };
}

export function searchPush(): any {
  return function (dispatch: any, getState: any) {
    onQueryUpdate(dispatch, getState());
  };
}

export function addValues(
  newValues: string[] | number[],
  filterField?: string,
): any {
  return function (dispatch: Dispatch, getState: Function) {
    dispatch(addValue(newValues, filterField));
  };
}

export function removeValues(
  removedField: string[] | number[],
  filterField?: string,
): any {
  return function (dispatch: Dispatch, getState: Function) {
    dispatch(removeValue(removedField, filterField));
  };
}

export function updateDisplayFields(newDisplayFields: string[]): any {
  return function (dispatch: Dispatch) {
    dispatch(setDisplayFields(newDisplayFields));
  };
}

export function updateSortOrder(newSortField: any, newSortOrder: any): any {
  return function (dispatch: Dispatch, getState: Function) {
    dispatch(setSortOrder(newSortField, newSortOrder));
    onQueryUpdate(dispatch, getState());
  };
}

export function updateFilterAndQueryUpdate(
  filterField: string,
  filterValue: string | number | number[],
): any {
  return function (dispatch: Dispatch, getState: Function) {
    dispatch(updateFilter(filterField, filterValue));
    onQueryUpdate(dispatch, getState());
  };
}
